/**
 * Ecommerce Studio — production app bundle
 * data-section attributes map to future Shopify / CMS sections.
 */
(function () {
  "use strict";

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mobile = window.matchMedia("(max-width: 920px)").matches;

  const nav = document.getElementById("nav");
  const menuToggle = document.getElementById("menuToggle");
  const mobileDrawer = document.getElementById("mobileDrawer");
  const stickyCta = document.getElementById("stickyCta");
  const hero = document.querySelector(".hero");
  const heroStage = document.querySelector(".hero-stage");
  const navLinks = document.querySelectorAll(".nav-links a, .mobile-panel a[href^='#']");

  const sectionIds = ["how", "showcase", "features", "testimonials", "pricing", "faq", "final"];

  let progressWrap = document.querySelector(".scroll-progress");
  if (!progressWrap) {
    progressWrap = document.createElement("d" + "iv");
  progressWrap.className = "scroll-progress";
  progressWrap.setAttribute("role", "progressbar");
  progressWrap.setAttribute("aria-label", "تقدّم التمرير");
  progressWrap.setAttribute("aria-valuemin", "0");
  progressWrap.setAttribute("aria-valuemax", "100");
  progressWrap.setAttribute("aria-valuenow", "0");
  progressWrap.innerHTML = '<div class="scroll-progress-bar"></div>';
    document.body.prepend(progressWrap);
  }

  const bar = progressWrap.querySelector(".scroll-progress-bar");

  let scrollTicking = false;

  function updateScrollUI() {
    const y = window.scrollY;

    if (nav) nav.classList.toggle("scrolled", y > 20);

    if (stickyCta && hero) {
      const heroBottom = hero.offsetTop + hero.offsetHeight;
      stickyCta.classList.toggle("visible", y > heroBottom - 100);
    }

    if (bar) {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const p = scrollable > 0 ? y / scrollable : 0;
      bar.style.transform = "scaleX(" + p + ")";
      progressWrap.setAttribute("aria-valuenow", String(Math.round(p * 100)));
    }

    let current = "";
    sectionIds.forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.offsetTop - (nav?.offsetHeight || 80) - 80;
      if (y >= top) current = id;
    });

    navLinks.forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || href.charAt(0) !== "#") return;
      link.classList.toggle("is-active", href.slice(1) === current);
    });

    if (!reduced && !mobile && heroStage && y < window.innerHeight) {
      heroStage.style.transform = "translateY(" + y * 0.04 + "px)";
    } else if (heroStage) {
      heroStage.style.transform = "";
    }

    scrollTicking = false;
  }

  function onScroll() {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(updateScrollUI);
    }
  }

  updateScrollUI();
  window.addEventListener("scroll", onScroll, { passive: true });

  function closeMenu() {
    menuToggle?.classList.remove("open");
    mobileDrawer?.classList.remove("open");
    document.body.classList.remove("menu-open");
    menuToggle?.setAttribute("aria-expanded", "false");
    mobileDrawer?.setAttribute("aria-hidden", "true");
  }

  function openMenu() {
    menuToggle?.classList.add("open");
    mobileDrawer?.classList.add("open");
    document.body.classList.add("menu-open");
    menuToggle?.setAttribute("aria-expanded", "true");
    mobileDrawer?.setAttribute("aria-hidden", "false");
  }

  menuToggle?.addEventListener("click", function () {
    mobileDrawer?.classList.contains("open") ? closeMenu() : openMenu();
  });

  mobileDrawer?.addEventListener("click", function (e) {
    if (e.target === mobileDrawer) closeMenu();
  });

  mobileDrawer?.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMenu();
  });

  if (stickyCta) document.body.classList.add("has-sticky-cta");

  const io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: "0px 0px -32px 0px" }
  );
  document.querySelectorAll(".reveal").forEach(function (el) {
    io.observe(el);
  });

  if (!reduced) {
    document.querySelectorAll(".who-grid, .steps, .feat-grid, .test-grid").forEach(function (grid) {
      Array.from(grid.children).forEach(function (el, i) {
        if (el.classList.contains("reveal")) {
          el.style.transitionDelay = 0.05 + i * 0.06 + "s";
        }
      });
    });
  }

  var bestPkg = document.querySelector(".pkg.best");
  if (bestPkg && !reduced) {
    new IntersectionObserver(
      function (entries) {
        bestPkg.classList.toggle("in-view", entries[0].isIntersecting);
      },
      { threshold: 0.45 }
    ).observe(bestPkg);
  }

  function initFaq(root) {
    var scope = root || document;
    scope.querySelectorAll(".faq-q:not([data-faq-bound])").forEach(function (btn, index) {
      btn.setAttribute("data-faq-bound", "true");
      var panel = btn.nextElementSibling;
      if (panel && !panel.id) {
        panel.id = "faq-answer-" + (index + 1) + "-" + Math.random().toString(36).slice(2, 7);
        btn.setAttribute("aria-controls", panel.id);
      }

      btn.addEventListener("click", function () {
        var item = btn.closest(".faq-item");
        var isOpen = item && item.classList.contains("open");

        document.querySelectorAll(".faq-item").forEach(function (i) {
          i.classList.remove("open");
          i.querySelector(".faq-q")?.setAttribute("aria-expanded", "false");
        });

        if (!isOpen && item) {
          item.classList.add("open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  initFaq();

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      var id = anchor.getAttribute("href");
      if (!id || id === "#") return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var offset = (nav?.querySelector(".nav-shell")?.offsetHeight || nav?.offsetHeight || 72) + 16;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: reduced ? "auto" : "smooth" });
    });
  });

  function initReveal() {
    document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
      io.observe(el);
    });
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      initReveal();
      if (event.target) initFaq(event.target);
    });
    document.addEventListener("shopify:section:reorder", initReveal);
  }
})();
